export default __webpack_public_path__ + "static/media/clearAllIcon.d2423779.svg";